import { Customer } from "api";
import Cookies from 'js-cookie'


export const getCustomerApi = () => new Customer({
  baseUrl: process.env.NEXT_PUBLIC_CUSTOMER,
  baseApiParams: {secure: true,
    headers:{
      "saas_id": process.env.NEXT_PUBLIC_SAAS_ID || "bread",
    }
  },
  securityWorker: ()=> {return {headers: { jwt_token: Cookies.get("jwt_token") || ''}}},
});